function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/tablecellproperties/tablecellpropertiesediting
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { addBorderRules } from '@ckeditor/ckeditor5-engine/src/view/styles/border';
import { addPaddingRules } from '@ckeditor/ckeditor5-engine/src/view/styles/padding';
import { addBackgroundRules } from '@ckeditor/ckeditor5-engine/src/view/styles/background';
import { downcastAttributeToStyle, upcastStyleToAttribute, upcastBorderStyles } from './../converters/tableproperties';
import TableEditing from './../tableediting';
import TableCellPaddingCommand from './commands/tablecellpaddingcommand';
import TableCellWidthCommand from './commands/tablecellwidthcommand';
import TableCellHeightCommand from './commands/tablecellheightcommand';
import TableCellBackgroundColorCommand from './commands/tablecellbackgroundcolorcommand';
import TableCellVerticalAlignmentCommand from './commands/tablecellverticalalignmentcommand';
import TableCellHorizontalAlignmentCommand from './commands/tablecellhorizontalalignmentcommand';
import TableCellBorderStyleCommand from './commands/tablecellborderstylecommand';
import TableCellBorderColorCommand from './commands/tablecellbordercolorcommand';
import TableCellBorderWidthCommand from './commands/tablecellborderwidthcommand';
var VALIGN_VALUES_REG_EXP = /^(top|bottom)$/;
/**
 * The table cell properties editing feature.
 *
 * Introduces table cell model attributes and their conversion:
 *
 * - border: `borderStyle`, `borderColor` and `borderWidth`
 * - background color: `backgroundColor`
 * - cell padding: `padding`
 * - horizontal and vertical alignment: `horizontalAlignment`, `verticalAlignment`
 * - cell width and height: `width`, `height`
 *
 * It also registers commands used to manipulate the above attributes:
 *
 * - border: the `'tableCellBorderStyle'`, `'tableCellBorderColor'` and `'tableCellBorderWidth'` commands
 * - background color: the `'tableCellBackgroundColor'` command
 * - cell padding: the `'tableCellPadding'` command
 * - horizontal and vertical alignment: the `'tableCellHorizontalAlignment'` and `'tableCellVerticalAlignment'` commands
 * - width and height: the `'tableCellWidth'` and `'tableCellHeight'` commands
 *
 * @extends module:core/plugin~Plugin
 */

var TableCellPropertiesEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(TableCellPropertiesEditing, _Plugin);

  var _super = _createSuper(TableCellPropertiesEditing);

  function TableCellPropertiesEditing() {
    _classCallCheck(this, TableCellPropertiesEditing);

    return _super.apply(this, arguments);
  }

  _createClass(TableCellPropertiesEditing, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var editor = this.editor;
      var schema = editor.model.schema;
      var conversion = editor.conversion;
      var locale = editor.locale;
      editor.data.addStyleProcessorRules(addBorderRules);
      enableBorderProperties(schema, conversion);
      editor.commands.add('tableCellBorderStyle', new TableCellBorderStyleCommand(editor));
      editor.commands.add('tableCellBorderColor', new TableCellBorderColorCommand(editor));
      editor.commands.add('tableCellBorderWidth', new TableCellBorderWidthCommand(editor));
      enableHorizontalAlignmentProperty(schema, conversion, locale);
      editor.commands.add('tableCellHorizontalAlignment', new TableCellHorizontalAlignmentCommand(editor));
      enableProperty(schema, conversion, 'width', 'width');
      editor.commands.add('tableCellWidth', new TableCellWidthCommand(editor));
      enableProperty(schema, conversion, 'height', 'height');
      editor.commands.add('tableCellHeight', new TableCellHeightCommand(editor));
      editor.data.addStyleProcessorRules(addPaddingRules);
      enableProperty(schema, conversion, 'padding', 'padding');
      editor.commands.add('tableCellPadding', new TableCellPaddingCommand(editor));
      editor.data.addStyleProcessorRules(addBackgroundRules);
      enableProperty(schema, conversion, 'backgroundColor', 'background-color');
      editor.commands.add('tableCellBackgroundColor', new TableCellBackgroundColorCommand(editor));
      enableVerticalAlignmentProperty(schema, conversion);
      editor.commands.add('tableCellVerticalAlignment', new TableCellVerticalAlignmentCommand(editor));
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'TableCellPropertiesEditing';
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "requires",
    get: function get() {
      return [TableEditing];
    }
  }]);

  return TableCellPropertiesEditing;
}(Plugin); // Enables the `'borderStyle'`, `'borderColor'` and `'borderWidth'` attributes for table cells.
//
// @param {module:engine/model/schema~Schema} schema
// @param {module:engine/conversion/conversion~Conversion} conversion


export { TableCellPropertiesEditing as default };

function enableBorderProperties(schema, conversion) {
  schema.extend('tableCell', {
    allowAttributes: ['borderWidth', 'borderColor', 'borderStyle']
  });
  upcastBorderStyles(conversion, 'td');
  upcastBorderStyles(conversion, 'th');
  downcastAttributeToStyle(conversion, 'tableCell', 'borderStyle', 'border-style');
  downcastAttributeToStyle(conversion, 'tableCell', 'borderColor', 'border-color');
  downcastAttributeToStyle(conversion, 'tableCell', 'borderWidth', 'border-width');
} // Enables the `'horizontalAlignment'` attribute for table cells.
//
// @param {module:engine/model/schema~Schema} schema
// @param {module:engine/conversion/conversion~Conversion} conversion
// @param {module:utils/locale~Locale} locale The {@link module:core/editor/editor~Editor#locale} instance.


function enableHorizontalAlignmentProperty(schema, conversion, locale) {
  schema.extend('tableCell', {
    allowAttributes: ['horizontalAlignment']
  });
  var options = [locale.contentLanguageDirection == 'rtl' ? 'left' : 'right', 'center', 'justify'];
  conversion.attributeToAttribute({
    model: {
      name: 'tableCell',
      key: 'horizontalAlignment',
      values: options
    },
    view: options.reduce(function (result, option) {
      return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, option, {
        key: 'style',
        value: {
          'text-align': option
        }
      }));
    }, {})
  });
} // Enables the `'verticalAlignment'` attribute for table cells.
//
// @param {module:engine/model/schema~Schema} schema
// @param {module:engine/conversion/conversion~Conversion} conversion


function enableVerticalAlignmentProperty(schema, conversion) {
  schema.extend('tableCell', {
    allowAttributes: ['verticalAlignment']
  });
  conversion.attributeToAttribute({
    model: {
      name: 'tableCell',
      key: 'verticalAlignment',
      values: ['top', 'bottom']
    },
    view: {
      top: {
        key: 'style',
        value: {
          'vertical-align': 'top'
        }
      },
      bottom: {
        key: 'style',
        value: {
          'vertical-align': 'bottom'
        }
      }
    }
  });
  conversion.for('upcast') // Support for backwards compatibility and pasting from other sources.
  .attributeToAttribute({
    view: {
      attributes: {
        valign: VALIGN_VALUES_REG_EXP
      }
    },
    model: {
      name: 'tableCell',
      key: 'verticalAlignment',
      value: function value(viewElement) {
        return viewElement.getAttribute('valign');
      }
    }
  });
} // Enables conversion for an attribute for simple view-model mappings.
//
// @param {String} modelAttribute
// @param {String} styleName
// @param {module:engine/model/schema~Schema} schema
// @param {module:engine/conversion/conversion~Conversion} conversion


function enableProperty(schema, conversion, modelAttribute, styleName) {
  schema.extend('tableCell', {
    allowAttributes: [modelAttribute]
  });
  upcastStyleToAttribute(conversion, 'tableCell', modelAttribute, styleName);
  downcastAttributeToStyle(conversion, 'tableCell', modelAttribute, styleName);
}